export const GAME_MODES = {
  SOLO: 1,
  HEAD_TO_HEAD: 2,
};
